import CONST from "./Constant";

export const INITIAL_STATE = {
    user:{
        favorites: [], // Array of tool IDs
    },
    isLoggedIn:false,
    error:undefined,
    fetching:false,
    otpSent: false,
};

const Reducer = (state = INITIAL_STATE, action) => {

    const originalData = action?.payload?.data;
    const user = { ...originalData }; // shallow clone

    switch (action.type){

        case CONST.REFRESH_USER_SUCCESS:
            return {
                ...state,
                user: {
                    ...user,
                    favorites: user?.favorites || [],
                },
            }
        case CONST.REFRESH_USER_FAILED:
            return {
                ...state,
                error: action.payload,
                fetching: false
            }
        case CONST.REGISTER_USER_SUCCESS:
            return {
                ...state,
                user: user,
                isLoggedIn:false,
                error: undefined,
                fetching: false
            }
        case CONST.REGISTER_USER_FAILED:
            return {
                fetching: false,
                error: action.payload
            }
        case CONST.VERIFY_OTP_FAILED:
            return {
                ...state,
                fetching: false,
                error: action.payload
            }
        case CONST.VERIFY_OTP_SUCCESS:
            return {
                ...state,
                user: {
                    ...user,
                    favorites: user?.favorites || [],
                },
                isLoggedIn:true,
                error: undefined,
                fetching: false
            }
        case CONST.LOGIN_SUCCESS:
            return {
                user: {
                    ...user,
                    favorites: user?.favorites || [],
                },
                isLoggedIn: true,
                error: undefined,
                fetching: false
            };
        case CONST.LOGIN_FAILED:
            return {
                ...state,
                fetching: false,
                error: action.payload
            }
        case CONST.MARK_NOTIFICATION_READ_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    notifications: []
                }
            }
        case CONST.MARK_NOTIFICATION_READ_FAILED:
            return {
                ...state,
                error: action.payload
            }
        case CONST.RESEND_OTP_SUCCESS:
            return {
                ...state,
                otpSent: true,
            }
        case CONST.LOGIN_LOADING:
            return {
                fetching: true
            }
        case CONST.LOGOUT_SUCCESS:
            return INITIAL_STATE;
        case CONST.LOGOUT_FAILED:
            return {
                fetching: false,
                error: action.payload
            }
        case CONST.LOGOUT_LOADING:
            return {
                fetching: true
            }
        case CONST.REFRESH_TOKEN_LOADING:
            return {
                ...state,
                user: {
                    ...action.payload.user,
                    favorites: action.payload.user?.favorites || [],
                },
                isLoggedIn: true,
                // Token is now stored in httpOnly cookies, not Redux state
                error: undefined,
                fetching: false
            }
        case CONST.TOGGLE_FAVORITE:
            const toolId = action.payload;
            const currentFavorites = state.user?.favorites || [];
            const isFavorite = currentFavorites.includes(toolId);
            
            const updatedFavorites = isFavorite
                ? currentFavorites.filter(id => id !== toolId)
                : [...currentFavorites, toolId];
            
            return {
                ...state,
                user: {
                    ...state.user,
                    favorites: updatedFavorites,
                },
            };
        default:
            return state;
    }
}

export default Reducer;